/* global google */
import axios from 'axios';
import config from '../config/';
import queryString from 'query-string';

/**
 * A promise based helper class to communicate in a standardized way with the
 * Hermes PSF backend.
 */
class HermesPSF {

  constructor() {
    // defaults, mostly taken from the previous version
    this.options = {
      maxResult: 20,
      maxDist: 30000,
      acceptSuitCases: false,
      hasBoxes: false,
      ident: false,
      openAtDayOfWeek: '',
      openAtTime: '',
      country: 'de',
      countries: 'de'
    };
  }

  removeFilter(filter) {
    if (filter === 'luggage') {
      this.options.acceptSuitCases = false;
    }

    if (filter === 'boxes') {
      this.options.hasBoxes = false;
    }

    if (filter === 'time') {
      this.options.open = false;
      this.options.openAtDayOfWeek = '';
      this.options.openAtTime = '';
    }
  }

  setFilter({luggage, boxes, time}) {
    this.options.hasBoxes = boxes;
    this.options.acceptSuitCases = luggage;

    // reset (in case user deselects checkbox)
    this.options.open = false;
    this.options.openAtDayOfWeek = '';
    this.options.openAtTime = '';

    if (time.enable) {
      this.options.open = true;
      this.options.openAtDayOfWeek = time.day.toUpperCase();
      this.options.openAtTime = `${time.hour}:${time.minute}`;
    }
  }

   pushToDataLayer(options) {
    window.dataLayer = window.dataLayer || [];

    if (options.consumerName) {
        window.dataLayer.push({
            pageId: 'PaketShop Finder',
            psfinderCustomer: options.consumerName
        });
    }
    else if (options.r) {
        window.dataLayer.push({
            pageId: 'PaketShop Finder',
            psfinderCustomer: options.r
        });
    }
  }

  mapLegacyOptions(options) {
    if (options.consumerName) {
      this.options.consumerName = options.consumerName;
    }

    if (options.consumerPassword) {
      this.options.consumerPassword = options.consumerPassword
    }

    if (options.countries) {
      this.options.countries = options.countries
      this.options.country = options.countries;
    }

    if (options.package) {
      this.options.hasBoxes = options.package;
    }

    if (options.db) {
      this.options.acceptsSuitcases = options.db;
    }

    if (options.open) {
      const days = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
      this.options.openAtDayOfWeek = days[parseInt(options.weekday,10)-1].toUpperCase();
      this.options.openAtTime = !!options.time ? options.time : '12:00';
    }
  }

  // FIXME: extract the google functions into their own class
  // get the address for a position using the Google Maps API
  positionToAddress(position) {
    return new Promise((resolve, reject) => {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({
        location: position
      }, (response, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          resolve(response[0].formatted_address)
        } else {
          reject({response, status});
        }
      })
    }) // note: the action should deal with error handling
  }

  // converts address to lat/lng
  addressToPosition(address, country, placesDetailsLAT, placesDetailsLNG) {
    // if available, use lat/lng from autocomplete (via PlaceService Google API call) and don't make additional "GeocodeService Google API call"
    if (placesDetailsLAT && placesDetailsLNG) {
        return new Promise((resolve) => {
            resolve({
                lat: placesDetailsLAT,
                lng: placesDetailsLNG
              });
        })
    }

    const searchRequest = {
      address,
      region: 'DE',
      componentRestrictions: {
        country
      }
    };

    // make "GeocodeService Google API call" to get lat/lng from the address
    return new Promise((resolve, reject) => {
        const geocoder = new google.maps.Geocoder();

        geocoder.geocode(searchRequest, (response, status) => {
            if (status === 'OK') {
                resolve({
                    lat: response[0].geometry.location.lat(),
                    lng: response[0].geometry.location.lng()
                });
            } else {
                reject({ response, status });
            }
        })
    }); // note: the action should deal with error handling
  }

  checkOptions(options) {
    if (!options.countries) {
      throw {message: 'country has not been defined'};
    }
  }

  request(endpoint, params) {
    try {
      // this.checkOptions(params);

        return axios.get(endpoint, {
            headers: {
            'Access-Control-Allow-Origin': '*',
            'Apikey': config.apiKey.value
            },
            params
        }); // note: the action should deal with error handling
    } catch (e) {
      return Promise.resolve({data: e.message});
    }
  }

  // ask the HermesPSF API for the shops at a specific position
  getShopsAt({lat, lng}) {
    const params = Object.assign({}, this.options, { lat, lng });
    return this.request(config.psfLocationEndpoint, params);
  }

  // get shop details by its id
  getShopById(parcelShopNumber) {
    const params = {
        'country': this.options.country.toLowerCase(),
        'parcelShopNo': parcelShopNumber
    };

    //! creates ajax Request URL: https://paketshop-int.myhermes.de/psfinder-api/parcelshop/?country=de&parcelShopNo=664293

    return this.request(config.psfDetailEndpoint, params);
  }

  //! ?
  getParcelShopImageById(parcelShopNumber) {
    // sample
    // getParcelShopImageById?mandantId=DE&consumerName=HLG000008&parcelShopNumber=629672&consumerPassword=b148ad05953889c9
    const parser = document.createElement('a');

    parser.href = config.psfImageEndpoint;
    parser.search = queryString.stringify({
      country: this.options.country.toLowerCase(),
      parcelShopNo: parcelShopNumber,
      apiKey: config.apiKey.value
    });

    return parser.href;
  }
}

export const hpsf = new HermesPSF();
window.hpsf = hpsf;
export default hpsf;
